import React, {Component} from "react";
import PropTypes from "prop-types";
import {connect} from "react-redux";
import ComplexParam from "@mnjsplatform/components/lib/common/ComplexParam";
import i18next from "i18next";
import PopupWrapper from "../Common/PopupWrapper";
import ReactToPrint from 'react-to-print';
import "./../../styles/RequestStyles.css";
import {formatMnDate} from "@mnjsplatform/data/lib/utils/formatData";

class PrintRequest extends Component {
    constructor(props, context) {
        super(props, context);

        this.refReport = React.createRef();
    }

    componentDidMount() {
        this.initialize();
    }

    async initialize() {
        try {
            await this.props.dispatch(this.props.CompHolidayApp_PrintPO.reset());
            await this.props.dispatch(this.props.CompHolidayApp_PrintPO.execute(this.props.rowKey, {
                withParams: false,
                newItem: true
            }));
        } catch (e) {
            console.error(e);
        }
    }

    renderButtons = () => {
        return (<div className="modal-footer text-right">
            <div className="text-right">
                <ReactToPrint
                    trigger={() => <button className="btn btn-regular -goahead">{i18next.t("Print")}</button>}

                    content={() => this.refReport.current}
                />
                <button className="btn btn-regular"
                        onClick={this.props.onClose}>{i18next.t('Close')}
                </button>

            </div>
        </div>)
    }

    renderPrintView = (h) => {
        return (
            <div className="printRequest_mn-report" id="printRequest_report" ref={this.refReport}>
                <table className="printRequest_mn-report-header">
                    <tbody>
                    <tr>
                        <td>
                            {h.ed("HolidayAppSendToProf")}
                            <hr/>
                            <div>
                                <sub>({i18next.t("HolidayAppSendToProf_Label")})</sub>
                            </div>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            {h.ed("HolidayAppSendToPers")}
                            <hr/>
                            <div>
                                <sub>({i18next.t("HolidayAppSendToPers_Label")})</sub>
                            </div>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <div className="text-left"><b>{i18next.t("From")}</b> {h.ed("Title")}</div>
                            <hr/>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <div className="text-left">{h.ed("Department")}</div>
                            <hr/>
                            <div>
                                <sub>({i18next.t("HolidayAppSendToTitleDepartament_Label")})</sub>
                            </div>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            {h.ed("PreferredName")}
                            <hr/>
                            <div>
                                <sub>({i18next.t("HolidayAppSendToPreferredName_Label")})</sub>
                            </div>
                        </td>
                    </tr>
                    <tr>
                        <td className="text-left">
                            <b>{i18next.t('TabNum')}:</b> {h.ed("TabNum")}
                            <hr/>
                        </td>
                    </tr>
                    </tbody>
                </table>
                <div className="printRequest_mn-report-body">
                    <h3>{i18next.t("Request")}</h3>
                    {i18next.t('Request_DayOff', {date: formatMnDate(h.row["DateHoliday"]), hours: h.row["HourHolidayStr"]})}
                </div>
                <table className="printRequest_mn-report-signature">
                    <tbody>
                    <tr>
                        <td className="font-weight-bold">{i18next.t('Date')}</td>
                        <td style={{width: "45%"}}>&nbsp;</td>
                        <td className="font-weight-bold">{i18next.t('EmployeeSignature')}</td>
                    </tr>
                    {/*<tr style={{height: "50px"}}>
                        <td colSpan="3"></td>
                    </tr>
                    <tr>
                        <td style={{fontWeight: "bold"}}>Дата</td>
                        <td style={{width: "45%"}}>&nbsp;</td>
                        <td>Подпись руководителя</td>
                    </tr>*/}
                    {/*<tr>
                        <td colSpan="2">&nbsp;</td>
                        <td style={{border: "none"}}>{h.ed("ChiefFIO")}</td>
                    !--    ФИО руководителя
                    </tr>*/}
                    </tbody>
                </table>
            </div>
        )
    }

    render() {
        return (
            <PopupWrapper popupVisible={true} title={i18next.t('DayOff_PrintStatement')}
                          onClose={this.props.onClose} instructionId="11"
                          renderButtons={this.renderButtons}>

                <ComplexParam dataItem={this.props.CompHolidayApp_PrintPO}
                              showApplyButton={false} showSearchBar={false} readOnly={false}
                              renderParams={this.renderPrintView}
                />
            </PopupWrapper>
        )
    }
}

PrintRequest.propTypes = {
    dispatch: PropTypes.func.isRequired,
    onClose: PropTypes.func,
    rowKey: PropTypes.object,
    CompHolidayApp_PrintPO: PropTypes.object
}

PrintRequest.defaultProps = {};

function mapStateToProps(state, ownProps) {
    return {
        CompHolidayApp_PrintPO: state.dayOffState.CompHolidayApp_PrintPO
    }
}

export default connect(mapStateToProps)(PrintRequest)
